import { FC } from "react";

import ConfirmActionModal from "components/modals/ConfirmActionModal";

interface IProps {
  isOpen: boolean;
  onDiscardChanges: () => void;
  onBackToEditing: () => void;
  children: React.ReactNode;
}

export const ChangesNotSavedModal: FC<IProps> = ({ isOpen, children, onDiscardChanges, onBackToEditing }) => {
  if (!isOpen) {
    return null;
  }

  return (
    <ConfirmActionModal
      onClose={onBackToEditing}
      heading="Changes not saved"
      primaryAction={{
        label: "Back to editing",
        onClick: onBackToEditing,
        actionType: "primary",
      }}
      secondaryAction={{
        label: "Discard changes",
        onClick: onDiscardChanges,
      }}
    >
      {children}
    </ConfirmActionModal>
  );
};
